import { createSlice } from "@reduxjs/toolkit";

const catalogSlice = createSlice({
  name: "catalog",
  initialState: { products: [], lines: [], categories: [] },
  reducers: {
    addCategoriesList: (state, action) => {
      return { ...state, categories: action.payload };
    },
    addLinesList: (state, action) => {
      return { ...state, lines: action.payload };
    },
    addProductsList: (state, action) => {
      return { ...state, products: action.payload };
    },
    addCompetitorsList: (state, action) => {
      return { ...state, competitors: action.payload };
    },
    addBrandsList: (state, action) => {
      return { ...state, brands: action.payload };
    },
    addEventsList: (state, action) => {
      return { ...state, events: action.payload };
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = catalogSlice;

// Extract and export each action creator by name
export const {
  addCategoriesList,
  addLinesList,
  addProductsList,
  addCompetitorsList,
  addBrandsList,
  addEventsList,
} = actions;

// Export the reducer, either as a default or named export
export default reducer;
